import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { MessageCircle } from 'lucide-react';
const screenshots = [{
  src: 'https://cdn.magicpatterns.com/uploads/2Rr9TL1nZsKcUqEAJYxgUh/1000532633_(1080×569).jpg',
  alt: 'Mensaje agradeciendo el libro tras leer la mitad',
  platform: 'WhatsApp'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/bm2tm2dKAFcLcnvbtgCrpB/68e5e391db7fe_Imagen-de-WhatsApp-2024-11-14-a-las-10.30.48_270654df-1-480x200.jpg',
  alt: 'Mensaje de agradecimiento desde República Dominicana',
  platform: 'WhatsApp'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/fiey6HNsbdzwh1dQHKcqc7/68e5e600ef716_4-480x113.jpg',
  alt: 'Comentario de Andrea Gutierrez sobre el libro',
  platform: 'Facebook'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/rVc5sKc1hgEdza5GJUKuWj/68e5e642ebf04_8.jpg',
  alt: 'Comentario de amparoescobar483 manifestando',
  platform: 'Instagram'
}];
export function RealTestimonials() {
  return <section className="py-20 px-4 bg-brand-bg relative overflow-hidden" data-id="element-248">
      <div className="max-w-5xl mx-auto relative z-10" data-id="element-249">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-250">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-brand-rose/10 rounded-full mb-6" data-id="element-251">
            <MessageCircle className="w-8 h-8 text-brand-rose" data-id="element-252" />
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-brand-plum mb-4" data-id="element-253">
            Mensajes Reales de Personas Como Tú
          </h2>
          <p className="text-lg text-brand-textLight max-w-2xl mx-auto" data-id="element-254">
            Cada día llegan mensajes que llenan de alegría a la Abu. Estos son
            solo algunos de ellos:
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8" data-id="element-255">
          {screenshots.map((s, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.15
        }} whileHover={{
          y: -6
        }} className="bg-white rounded-2xl p-4 shadow-lg border border-brand-gold/20 relative" style={{
          transform: i === 1 ? 'rotate(-1deg)' : i === 2 ? 'rotate(1.5deg)' : 'rotate(-0.5deg)'
        }} data-id="element-256">
              <div className="absolute -top-3 left-4 bg-brand-rose text-white text-xs font-bold px-3 py-1 rounded-full shadow-md" data-id="element-257">
                {s.platform}
              </div>
              <img src={s.src} alt={s.alt} className="w-full h-auto rounded-xl" loading="lazy" data-id="element-258" />
            </motion.div>)}
        </div>

        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="text-center mt-12 font-script text-2xl md:text-3xl text-brand-plum" data-id="element-259">
          "Cada mensaje me llena el corazón, mi pequeña." 🌸
        </motion.p>
      </div>

      <div className="absolute -bottom-20 -left-20 w-72 h-72 bg-brand-rose/5 rounded-full blur-3xl -z-10" data-id="element-260"></div>
    </section>;
}